import { mapGetters } from "vuex";

export default {
  data: () => ({
  
  }),

  mounted () {

  },
  methods: {
    reg(){
      this.$root.$emit('modal.reg');
    }
  },
  computed: {
    ...mapGetters([])
  },
}



// WEBPACK FOOTER //
// ./src/pages/Service/service.js